import React from 'react';
import LoadingIcon from '../Icons/LoadingIcon';
import { CircularLoadingWrapper } from './styles';

export interface ICircularLoadingProps {
  size?: number;
}

const CircularLoading = (props: ICircularLoadingProps): React.JSX.Element => {
  return (
    <CircularLoadingWrapper size={props.size}>
      <LoadingIcon />
    </CircularLoadingWrapper>
  );
};

export default CircularLoading;
